import script from "./grid-head-cell.vue?vue&type=script&setup=true&lang=ts"
export * from "./grid-head-cell.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__